export const LOADING_REQUIREMENTS_MONITOR = "LOADING_REQUIREMENTS_MONITOR";
export const SAVE_LOADING_REQUIREMENTS_MONITOR = "SAVE_LOADING_REQUIREMENTS_MONITOR";
export const GET_REQUIREMENTS_MONITOR = "GET_REQUIREMENTS_MONITOR";
export const FORM_FAIL = "FORM_FAIL";
export const REQUIREMENTS_MONITOR_FAIL = "REQUIREMENTS_MONITOR_FAIL";
export const LOADING_REQUIREMENTS_MONITOR_BY_ID = "LOADING_REQUIREMENTS_MONITOR_BY_ID";
export const GET_REQUIREMENTS_MONITOR_BY_ID = "GET_REQUIREMENTS_MONITOR_BY_ID";
export const LOADING_REQUIREMENTS_URL = "LOADING_REQUIREMENTS_URL";
export const REQUIREMENTS_URL_FAIL = "REQUIREMENTS_URL_FAIL";
export const GET_REQUIREMENTS_URL = "GET_REQUIREMENTS_URL";
export const SAVE_LOADING_REQUIREMENTS_URL = "SAVE_LOADING_REQUIREMENTS_URL";
export const FORM_URL_FAIL = "FORM_URL_FAIL";
